module.exports = __webpack_public_path__ + "img/dashboard.e936a72c.png";